// "a" or "an" before a word, by its first sound (vowel letter), for messages
// built from a type name such as expense or income.
export function withArticle(word) {
  const w = String(word || '').trim();
  if (!w) return '';
  return `${/^[aeiou]/i.test(w) ? 'an' : 'a'} ${w}`;
}
